import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { TLeadScore } from 'crono-fe-common/types/leadScore';

export const useGetProspectScore = (
  prospectId: string | null | undefined,
  enabled = true,
) => {
  return useQuery<Response<TLeadScore['score']>, CronoError>({
    queryKey: [ENDPOINTS.score.prospect.main, prospectId],
    queryFn: () => {
      const request: Request = {
        url: `${ENDPOINTS.score.prospect.main}?prospectId=${prospectId}`,
        config: {
          method: 'get',
        },
      };
      return client(request);
    },
    enabled: !!prospectId && enabled,
  });
};
